// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__309pQ","header":"ClearentDisclaimer_header__1vosk","inner":"ClearentDisclaimer_inner__2InEX"};